import { makeStyles, Theme } from '@material-ui/core/styles'

export default makeStyles((theme: Theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  sticky: {
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
    borderBottom: `1px solid ${theme.palette.divider}`,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  accountsList: {
    flex: 1,
    width: '100%',
    overflow: 'auto',
  },
  list: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  listChild: {
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(3),
  },
  listText: {
    margin: 0,
    width: '100%',
  },
  listTextPrimary: {
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
  },
  checkbox: {
    padding: theme.spacing(0.5),
    marginRight: theme.spacing(1),
  },
  checked: {
    color: theme.palette.primary.main,
  },
  listLayout: {
    padding: 0,
    width: '100%',
  },
  listItemContainer: {
    padding: 0,
  },
  gutters: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  listItemRoot: {
    padding: '4px 6px',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  listItemTextRoot: {
    margin: 0,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  listItemTextPrimary: {
    fontSize: '0.875rem',
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  listItemSecondaryActionRoot: {
    right: theme.spacing(1),
    position: 'relative',
    transform: 'none',
  },
  dropButton: {
    padding: 4,
    marginLeft: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  searchContainer: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  tooltip: {
    backgroundColor: '#222',
    '&::after': {
      display: 'none',
    },
  },
  selectAllContainer: {
    border: '1px solid #ccc',
    borderRadius: '4px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      border: '1px solid #222',
      backgroundColor: theme.palette.action.hover
    },
  },
  spinner: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  grade_icon: {
    fontSize: '1rem',
    marginLeft: theme.spacing(0.5),
    color: theme.palette.text.secondary,
  },
}))
